import React from "react"
import { Chip } from "@mui/material"
import { I18n } from "utils/i18n-shim"

/**
 * @param {import("@mui/material").ChipProps & {backgroundColor: string, textColor?: string}} props
 */
export const StateTag = ({
  backgroundColor,
  textColor = "grey.600",
  ...chipProps
}) => {
  return (
    <Chip
      sx={{
        fontWeight: 500,
        color: textColor,
        backgroundColor
      }}
      {...chipProps}
      size="small"
    />
  )
}

/**
 * @param {import("@mui/material").ChipProps & {active: boolean}} props
 */
export const ActiveTag = ({ active, ...chipProps }) => {
  const backgroundColor = active ? "success.light" : "error.light"
  const label = active ? I18n.t("active") : I18n.t("inactive")

  return (
    <StateTag {...chipProps} backgroundColor={backgroundColor} label={label} />
  )
}
